import { useMutation } from '@tanstack/react-query';
import { SwitchInlineEditor } from 'components/inline_edit/ToggleInlineEditor';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { updateLocation } from 'utils/location';

export function LocationDraftIssuesAvailableCell({
    rowData,
    onChange,
}: LocationsTableCellProps) {
    const { canEditLocationDetails } = usePermissions();
    const { showToast } = useNotificationContext();

    const { mutate: setDraftIssuesAvailable, isPending } = useMutation({
        meta: { name: 'update-location' },
        mutationFn: (draftIssuesAvailable: boolean) =>
            updateLocation(rowData, {
                DraftIssuesAvailableToCustomerAdmins: draftIssuesAvailable,
            }),

        onSuccess: () => {
            onChange();
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save location draft issues availability',
            }),
    });

    return (
        <SwitchInlineEditor
            value={rowData.Settings.DraftIssuesAvailableToCustomerAdmins}
            onConfirm={(val) => setDraftIssuesAvailable(val ?? false)}
            isDisabled={isPending || !canEditLocationDetails}
            renderValue={(val) => (val ? 'Yes' : 'No')}
        />
    );
}
